import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setBusinessVatRegistration,
  getBusinessVatRegistration,
  setPMCData,
} from '../../features/pmc/pmcJourneySlice';
import { checkValidBusinessVAT } from '../../regex/regex';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkVATNumber } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const PmcClientVATNumber = () => {
  const [errorList, setErrorList] = useState([]);
  const businessVatRegistrationRedux = useSelector(getBusinessVatRegistration);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.PmcClientVATNumber.s10',
    "Enter your client's VAT registration number  - OZEV Electric Vehicle Chargepoint Grant - GOV.UK"
  );

  const dispatch = useDispatch();

  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState('');

  const handleBusinessVatRegistration = (event) => {
    dispatch(setBusinessVatRegistration(event.target.value));
  };

  const errorMsgValid = copyProvider.getCopy(
    'pmcClientReg.PmcClientVATNumber.s1',
    'Enter a valid VAT Registration number that consists of 9 characters and can contain letters and numbers'
  );
  const errorMsgNotValid = copyProvider.getCopy(
    'pmcClientReg.PmcClientVATNumber.s2',
    'There is no company that matches the UK VAT registration number you have provided'
  );
  const errorMsgAlreadyExists = copyProvider.getCopy(
    'pmcClientReg.PmcClientVATNumber.s9',
    'This number is already in use with another account'
  );

  const showError = {
    children: errorMsgValid,
  };

  const showErrorNotValidAPI = {
    children: errorMsgNotValid,
  };

  const showErrorAlreadyExistsAPI = {
    children: errorMsgAlreadyExists,
  };

  const handleBtnClick = () => {
    if (checkValidBusinessVAT.test(businessVatRegistrationRedux)) {
      setErrorMsg(null);

      checkVATNumber({ vatRegNumber: businessVatRegistrationRedux })
        .then((response) => {
          const { data } = response;

          dispatch(setPMCData(data));

          history.push('/pmcClientReg/confirm-business-VAT');
        })
        .catch((error) => {
          if (error.code === 'functions/already-exists') {
            setErrorMsg(showErrorAlreadyExistsAPI);
            setErrorList([
              {
                ...showErrorAlreadyExistsAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              {
                ...showErrorNotValidAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          }
        });
    } else if (!checkValidBusinessVAT.test(businessVatRegistrationRedux)) {
      setErrorMsg(showError);
      setErrorList([
        {
          ...showError,
          href: '#companyRegistrationNumber',
        },
      ]);
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div className="govuk-form-group">
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'pmcClientReg.PmcClientVATNumber.s3',
            "Enter your client's VAT registration number"
          )}
        </h1>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'pmcClientReg.PmcClientVATNumber.s4',
            "We will use this to confirm your client's business details."
          )}
        </p>
        <div className="govuk-form-group">
          <div className="govuk-body">
            <Input
              errorMessage={errorMsg}
              label={{
                children: copyProvider.getCopy(
                  'pmcClientReg.PmcClientVATNumber.s5',
                  'UK VAT registration number'
                ),
              }}
              hint={{
                children: copyProvider.getCopy(
                  'pmcClientReg.PmcClientVATNumber.s6',
                  'This is the unique number that HMRC provides to UK businesses when they register for tax payment'
                ),
              }}
              id="companyRegistrationNumber"
              className="govuk-input govuk-!-width-two-thirds"
              name="companyRegistration"
              type="text"
              value={businessVatRegistrationRedux}
              onChange={(event) => handleBusinessVatRegistration(event)}
            />
          </div>
        </div>
      </div>
      <div className="govuk-body govuk-!-font-size-19 govuk-!-padding-bottom-6">
        <Link className="govuk-link " to="/pmcClientReg/cannot-proceed">
          {copyProvider.getCopy(
            'pmcClientReg.PmcClientVATNumber.s7',
            "My client doesn't have a VAT registration number"
          )}
        </Link>
      </div>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('pmcClientReg.PmcClientVATNumber.s8', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default PmcClientVATNumber;
